import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/industries/financial')({
  head: () => ({
    ...buildSeoHead({ path: '/industries/financial', ...ROUTE_META['/industries/financial'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Industries', path: '/industries' }, { name: 'Financial Services', path: '/industries/financial' }])),
      jsonLdScript(buildWebPageSchema({ path: '/industries/financial', ...ROUTE_META['/industries/financial'] })),
    ],
  }),
});
